// Validation schema using Yup

export interface PatientIdConfig {
  prefix: string;
  serialNumberStart: string;
}

// Initial form values
export const initialValues: PatientIdConfig = {
  prefix: "EC",
  serialNumberStart: "001",
};
